import React, { Component } from "react";
import cookie from "react-cookies";
import logolight from "../../assets/images/logo-light.png";

class FooterLinks extends Component {
  render() {
    return (
      <>
        {cookie.load("session-id-qt") && (
          <button
            className="signout"
            onClick={() => {
              //clear all cookies in document
              if (document.cookie) {
                let cookies = document.cookie.split(";");
                for (let i = 0; i < cookies.length; i++) {
                  let cookie = cookies[i];
                  let eqPos = cookie.indexOf("=");
                  let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                  document.cookie =
                    name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
              }
              //clear local storage
              localStorage.clear();
              window.location.reload();
            }}
          >
            Sign out
          </button>
        )}
        <div className="float-sm-right mt-4 mt-sm-0">
          <p className="copyright-desc text-white mb-0">
            {new Date().getFullYear()} © QikTruck. Pty Ltd. South Africa.
          </p>
          <img src={logolight} alt="" height="40" />
        </div>
      </>
    );
  }
}

export default FooterLinks;
